import { render, staticRenderFns } from "./StatusEnvioExtratos.vue?vue&type=template&id=38cf34bf&"
import script from "./StatusEnvioExtratos.vue?vue&type=script&lang=js&"
export * from "./StatusEnvioExtratos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports